/*
 * Generated type guards for "JsonSchema.tsx".
 * WARNING: Do not manually change this file.
 */
import { JsonSchema7 } from './JsonSchema';

export function isJsonSchema7(obj: unknown): obj is JsonSchema7 {
  const typedObj = obj as JsonSchema7;
  return (
    ((typedObj !== null && typeof typedObj === 'object') ||
      typeof typedObj === 'function') &&
    (typeof typedObj['$ref'] === 'undefined' ||
      typeof typedObj['$ref'] === 'string') &&
    (typeof typedObj['$id'] === 'undefined' ||
      typeof typedObj['$id'] === 'string') &&
    (typeof typedObj['$schema'] === 'undefined' ||
      typeof typedObj['$schema'] === 'string') &&
    (typeof typedObj['title'] === 'undefined' ||
      typeof typedObj['title'] === 'string') &&
    (typeof typedObj['description'] === 'undefined' ||
      typeof typedObj['description'] === 'string') &&
    (typeof typedObj['multipleOf'] === 'undefined' ||
      typeof typedObj['multipleOf'] === 'number') &&
    (typeof typedObj['maximum'] === 'undefined' ||
      typeof typedObj['maximum'] === 'number') &&
    (typeof typedObj['exclusiveMaximum'] === 'undefined' ||
      typeof typedObj['exclusiveMaximum'] === 'number') &&
    (typeof typedObj['minimum'] === 'undefined' ||
      typeof typedObj['minimum'] === 'number') &&
    (typeof typedObj['exclusiveMinimum'] === 'undefined' ||
      typeof typedObj['exclusiveMinimum'] === 'number') &&
    (typeof typedObj['maxLength'] === 'undefined' ||
      typeof typedObj['maxLength'] === 'number') &&
    (typeof typedObj['minLength'] === 'undefined' ||
      typeof typedObj['minLength'] === 'number') &&
    (typeof typedObj['pattern'] === 'undefined' ||
      typeof typedObj['pattern'] === 'string') &&
    (typeof typedObj['additionalItems'] === 'undefined' ||
      typedObj['additionalItems'] === false ||
      typedObj['additionalItems'] === true ||
      (isJsonSchema7(typedObj['additionalItems']) as boolean)) &&
    (typeof typedObj['items'] === 'undefined' ||
      (isJsonSchema7(typedObj['items']) as boolean) ||
      (Array.isArray(typedObj['items']) &&
        typedObj['items'].every((e: any) => isJsonSchema7(e) as boolean))) &&
    (typeof typedObj['maxItems'] === 'undefined' ||
      typeof typedObj['maxItems'] === 'number') &&
    (typeof typedObj['minItems'] === 'undefined' ||
      typeof typedObj['minItems'] === 'number') &&
    (typeof typedObj['uniqueItems'] === 'undefined' ||
      typedObj['uniqueItems'] === false ||
      typedObj['uniqueItems'] === true) &&
    (typeof typedObj['maxProperties'] === 'undefined' ||
      typeof typedObj['maxProperties'] === 'number') &&
    (typeof typedObj['minProperties'] === 'undefined' ||
      typeof typedObj['minProperties'] === 'number') &&
    (typeof typedObj['required'] === 'undefined' ||
      (Array.isArray(typedObj['required']) &&
        typedObj['required'].every((e: any) => typeof e === 'string'))) &&
    (typeof typedObj['additionalProperties'] === 'undefined' ||
      typedObj['additionalProperties'] === false ||
      typedObj['additionalProperties'] === true ||
      (isJsonSchema7(typedObj['additionalProperties']) as boolean)) &&
    (typeof typedObj['definitions'] === 'undefined' ||
      (((typedObj['definitions'] !== null &&
        typeof typedObj['definitions'] === 'object') ||
        typeof typedObj['definitions'] === 'function') &&
        Object.entries<any>(typedObj['definitions']).every(
          ([key, value]) =>
            (isJsonSchema7(value) as boolean) && typeof key === 'string'
        ))) &&
    (typeof typedObj['properties'] === 'undefined' ||
      (((typedObj['properties'] !== null &&
        typeof typedObj['properties'] === 'object') ||
        typeof typedObj['properties'] === 'function') &&
        Object.entries<any>(typedObj['properties']).every(
          ([key, value]) =>
            (isJsonSchema7(value) as boolean) && typeof key === 'string'
        ))) &&
    (typeof typedObj['patternProperties'] === 'undefined' ||
      (((typedObj['patternProperties'] !== null &&
        typeof typedObj['patternProperties'] === 'object') ||
        typeof typedObj['patternProperties'] === 'function') &&
        Object.entries<any>(typedObj['patternProperties']).every(
          ([key, value]) =>
            (isJsonSchema7(value) as boolean) && typeof key === 'string'
        ))) &&
    (typeof typedObj['dependencies'] === 'undefined' ||
      (((typedObj['dependencies'] !== null &&
        typeof typedObj['dependencies'] === 'object') ||
        typeof typedObj['dependencies'] === 'function') &&
        Object.entries<any>(typedObj['dependencies']).every(
          ([key, value]) =>
            ((isJsonSchema7(value) as boolean) ||
              (Array.isArray(value) &&
                value.every((e: any) => typeof e === 'string'))) &&
            typeof key === 'string'
        ))) &&
    (typeof typedObj['enum'] === 'undefined' ||
      Array.isArray(typedObj['enum'])) &&
    (typeof typedObj['type'] === 'undefined' ||
      typeof typedObj['type'] === 'string' ||
      (Array.isArray(typedObj['type']) &&
        typedObj['type'].every((e: any) => typeof e === 'string'))) &&
    (typeof typedObj['allOf'] === 'undefined' ||
      (Array.isArray(typedObj['allOf']) &&
        typedObj['allOf'].every((e: any) => isJsonSchema7(e) as boolean))) &&
    (typeof typedObj['anyOf'] === 'undefined' ||
      (Array.isArray(typedObj['anyOf']) &&
        typedObj['anyOf'].every((e: any) => isJsonSchema7(e) as boolean))) &&
    (typeof typedObj['oneOf'] === 'undefined' ||
      (Array.isArray(typedObj['oneOf']) &&
        typedObj['oneOf'].every((e: any) => isJsonSchema7(e) as boolean))) &&
    (typeof typedObj['not'] === 'undefined' ||
      (isJsonSchema7(typedObj['not']) as boolean)) &&
    (typeof typedObj['format'] === 'undefined' ||
      typeof typedObj['format'] === 'string') &&
    (typeof typedObj['readOnly'] === 'undefined' ||
      typedObj['readOnly'] === false ||
      typedObj['readOnly'] === true) &&
    (typeof typedObj['writeOnly'] === 'undefined' ||
      typedObj['writeOnly'] === false ||
      typedObj['writeOnly'] === true) &&
    (typeof typedObj['examples'] === 'undefined' ||
      Array.isArray(typedObj['examples'])) &&
    (typeof typedObj['contains'] === 'undefined' ||
      (isJsonSchema7(typedObj['contains']) as boolean)) &&
    (typeof typedObj['propertyNames'] === 'undefined' ||
      (isJsonSchema7(typedObj['propertyNames']) as boolean)) &&
    (typeof typedObj['if'] === 'undefined' ||
      (isJsonSchema7(typedObj['if']) as boolean)) &&
    (typeof typedObj['then'] === 'undefined' ||
      (isJsonSchema7(typedObj['then']) as boolean)) &&
    (typeof typedObj['else'] === 'undefined' ||
      (isJsonSchema7(typedObj['else']) as boolean))
  );
}
